import { Component, OnInit } from '@angular/core';
import { ProxyDynamicService } from '../../shared/service/proxy-dynamic.service';
import { BalanceType, DeleteStatus, exportAsExcelFile, formatDataExport, ItemMode, ListServiceCardStatus, ServiceCardStatus, SharedService } from '../../shared/shared.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslateService } from '@ngx-translate/core';
import { ItemComponent } from '../item/item.component';
import { ChangeCardItemComponent } from '../change-card/change-card.component';
import { UpdateApartmentItemComponent } from '../update-apartment/update-apartment.component';
import { PopupConfirmComponent } from '../popup-confirm/popup-confirm.component';
import moment from "moment/moment";
import { ExchangeItemComponent } from '../exchange/exchange.component';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ColumnConfigExport } from '../../shared/models/config-export.model';
@Component({
  selector: 'app-service-card-list',
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
})
export class ListComponent implements OnInit {
  listStatus = ListServiceCardStatus;
  source: any[] = [];
  totalRows: number = 0;
  selectedRow: any = null;
  apartmentId: number | undefined;
  apartmentCode: string | undefined;
  filter: any = {
    limit: 15,
    page: 1,
    sort: 'card_no',
    card_id: null,
    card_owner: null,
    apartment_codes: null,
    status: null,
    activated_date: null,
    deleted: null
  };

  tableConfig = [
    { name: 'activated_date', title: 'doc.date', default: null, type: 'date', sortBy: 'DESC', width: '150px' },
    { name: 'card_no', title: 'card.code', default: null, type: 'textAsLink', sortBy: 'ASC' },
    { name: 'card_owner', title: 'service-card.owner', default: null, type: 'text', options: [], sortBy: 'ASC', width: '250px' },
    { name: 'apartment_codes', title: 'apartment.label', default: null, type: 'text', options: [], sortBy: 'ASC', width: '200px' },
    { name: 'total_balance', title: 'service-card.total-balance', default: null, type: 'number', options: [], sortBy: 'ASC' },
    { name: 'total_service_balance', title: 'service-card.total-service', default: null, type: 'number', options: [], sortBy: 'ASC'},
    { name: 'statusString', title: 'status.title', default: null, type: 'status', sortBy: 'ASC', options: this.listStatus },
  ];

  filterConfig = [
    { name: 'card_no', title: 'card.code', default: '', type: 'text', col: 8 },
    { name: 'card_owner', title: 'service-card.owner', default: '', type: 'text', col: 8 },
    { name: 'activated_date', title: 'doc.date', default: null, type: 'date-range', col: 8 },
    { name: 'apartment_codes', title: 'apartment.label', default: [], type: 'multi-select', col: 8, dbName: 'apartment', options: [] },
    {
      name: 'status', title: 'status.title', type: 'status-multi-select', col: 8, options: this.listStatus.filter((item: any) => item.value !== ServiceCardStatus.Deleted),
      default: [ServiceCardStatus.Active, ServiceCardStatus.Pending, ServiceCardStatus.Block]
    },
    { name: 'deleted', label: 'deleted', default: '', type: 'checkbox', col: 8 },
  ];

  constructor(
    private service: ProxyDynamicService,
    private modalService: NzModalService,
    private noti: NzNotificationService,
    private translate: TranslateService,
    private sharedService: SharedService,
    private datePipe: DatePipe,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.apartmentId = this.router.getCurrentNavigation()?.extras.state?.['apartmentId'];
    this.apartmentCode = this.router.getCurrentNavigation()?.extras.state?.['apartmentCode'];
    history.replaceState({}, '', this.router.url);
    if (this.apartmentId) {
      this.filterConfig.forEach((item: any) => {
        if (item.name === 'apartment_codes') {
          item.default = [this.apartmentId];
          item.searchKey = this.apartmentCode;
        }
      });
      this.filter.apartment_codes = [this.apartmentId];
    }
    this.getData();
  }

  getData(event?: any) {
    this.selectedRow = null;
    this.sharedService.showLoading(true);
    if (event) {
      Object.keys(event).forEach((key: any) => {
        this.filter[key] = key === 'page' && !event[key] ? 1 : event[key];
      })
    }
    this.service.getListServiceCard({
      page: this.filter.page || 1,
      limit: this.filter.limit,
      sortOrder: this.filter.sort.includes('-') ? 'DESC' : 'ASC',
      sortField: this.filter.sort.includes('-') ? this.filter.sort.replace('-', '') : this.filter.sort,
      searchFields: this.filterConfig.map((item: any) => {
        let value;
        if (item.type === 'checkbox' && this.filter[item.name]) {
          value = DeleteStatus.YES;
        } else if (item.type === 'date-range') {
          value = this.filter[item.name]?.map((date: Date) => moment(date).format('YYYY/MM/DD'));
        } else if (item.type === 'multi-select' || item.type === 'status-multi-select') {
          value = this.filter[item.name]?.length > 0 ? this.filter[item.name] : undefined;
        } else {
          value = this.filter[item.name];
        }

        if (this.filter[item.name]) {
          let obj = {
            field: item.name,
            operator: item.name === 'activated_date' ? '' : item.name === 'apartment_codes' || item.name === 'status' ? 'in' : '=',
            value
          }
          return obj;
        }
        return;
      }).filter(r => r && r.value),
    }).subscribe((res: any) => {
      this.totalRows = res.pagination.totalRecords;
      this.source = (res?.data || []).map((item: any) => {
        item.total_balance = Number(item.total_cash) + Number(item.total_cash_voucher);
        item.total_service_balance = Number(item.total_service) + Number(item.total_service_voucher);
        item.statusString = item.deleted === DeleteStatus.YES ? ServiceCardStatus.Deleted : item.status;
        return item;
      })
      this.sharedService.showLoading(false);
    }, (error: any) => {
      this.service.handleError(error)
    });
  }

  add() {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzClassName: 'modal-service-card',
      nzData: {
        mode: ItemMode.Add
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('service-card.addSuccess'));
        this.getData();
      }
    });
  }

  view($event: any) {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzClassName: 'modal-service-card',
      nzData: {
        mode: ItemMode.View,
        data: $event,
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('service-card.updateSuccess'));
      }
    });
  }

  edit($event: any) {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzClassName: 'modal-service-card',
      nzData: {
        mode: ItemMode.Edit,
        data: $event,

      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('service-card.updateSuccess'));
        this.getData();
      }
    });
  }

  delete($event: any) {
    const dataRow = $event;
    if (!!Number(dataRow.total_balance) || !!Number(dataRow.total_service_balance)) {
      this.noti.create('error', '', this.translate.instant('service-card.error-delete-card'));
      return;
    }
    this.service.deleteCard($event.card_id).subscribe(res => {
      if (res) {
        this.noti.create('success', '', this.translate.instant('service-card.deleteSuccess'));
        this.getData();
      }
    }, (error: any) => {
      this.service.handleError(error)
    });
  }

  checkedRowsSelected() {
    if (!this.selectedRow) {
      this.noti.info('', this.translate.instant('error-selectRow'));
      return false;
    }
    return true;
  }

  changeCard(event: any) {
    const modalRef = this.modalService.create({
      nzContent: ChangeCardItemComponent,
      nzWidth: '526px',
      nzClassName: 'modal-service-card',
      nzData: {
        dataRow: event
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('service-card.changeCardSuccess'));
        this.getData();
      }
    });
  }

  changeApartment() {
    if (!this.checkedRowsSelected()) return;
    if (this.selectedRow.status === ServiceCardStatus.Block) {
      this.noti.create('error', '', this.translate.instant('service-card.error-update-apartment'));
      return;
    }
    const modalRef = this.modalService.create({
      nzContent: UpdateApartmentItemComponent,
      nzWidth: '526px',
      nzClassName: 'modal-service-card',
      nzData: {
        dataRow: this.selectedRow
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('service-card.updateApartmentSuccess'));
        this.getData();
      }
    });
  }

  lockCard() {
    if (!this.checkedRowsSelected()) return;
    if (this.selectedRow.status === ServiceCardStatus.Block) {
      this.noti.create('error', '', this.translate.instant('service-card.error-card-locked'));
      return;
    }
    if (Number(this.selectedRow.total_cash_voucher) > 0 || Number(this.selectedRow.total_service_voucher) > 0) {
      this.noti.create('error', '', this.translate.instant('service-card.error-lock-card'));
      return;
    }
    const modalRef = this.modalService.create({
      nzContent: PopupConfirmComponent,
      nzWidth: '500px',
      nzClassName: 'modal-service-confirm',
      nzData: {
        dataRow: this.selectedRow
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '', this.translate.instant('service-card.lockCardSuccess'));
        this.getData();
      }
    });
  }

  onChangePage(event: any) {
    this.filter.page = event;
    this.getData();
  }

  onChangeSize(event: any) {
    this.filter.limit = event;
    this.getData();
  }

  onSort(event: any) {
    this.tableConfig.forEach((col) => {
      if (col['name'] === event) {
        this.filter['sort'] = col['sortBy'] === 'ASC' ? event : '-' + event;
        col['sortBy'] = col['sortBy'] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        col['sortBy'] = 'ASC'
      }
    });
    this.getData();
  }

  export() {
    this.service.getListServiceCard({
      page: 1,
      limit: this.totalRows,
      sortOrder: this.filter.sort.includes('-') ? 'DESC' : 'ASC',
      sortField: this.filter.sort.includes('-') ? this.filter.sort.replace('-', '') : this.filter.sort,
      searchFields: this.filterConfig.map((item: any) => {
        let value;
        if (item.type === 'checkbox' && this.filter[item.name]) {
          value = DeleteStatus.YES;
        } else if (item.type === 'date-range') {
          value = this.filter[item.name]?.map((date: Date) => moment(date).format('YYYY/MM/DD'));
        } else if (item.type === 'multi-select' || item.type === 'status-DatePipemulti-select') {
          value = this.filter[item.name]?.length > 0 ? this.filter[item.name] : undefined;
        } else {
          value = this.filter[item.name];
        }

        if (this.filter[item.name]) {
          let obj = {
            field: item.name,
            operator: item.name === 'activated_date' ? '' : item.name === 'apartment_codes' || item.name === 'status' ? 'in' : '=',
            value
          }
          return obj;
        }
        return;
      }).filter(r => r && r.value),
    }).subscribe((dataResult: any) => {
      let dataExport: any[] = [];
      if (dataResult?.data?.length > 0) {
        dataExport = dataResult.data.map((item: any) => ({
          ...item,
          total_balance: Number(item.total_cash) + Number(item.total_cash_voucher),
          total_service_balance: Number(item.total_service) + Number(item.total_service_voucher),
          statusString: item.deleted === DeleteStatus.YES ? ServiceCardStatus.Deleted : item.status,
        }));
      }
      let configColumn: ColumnConfigExport[] = [
        { field: 'activated_date', headerText: 'doc.date', type: 'date' },
        { field: 'card_no', headerText: 'card.code', type: 'text' },
        { field: 'card_owner', headerText: 'service-card.owner', type: 'text' },
        { field: 'apartment_codes', headerText: 'apartment.label', type: 'text' },
        { field: 'total_balance', headerText: 'service-card.total-balance', type: 'number' },
        { field: 'total_service_balance', headerText: 'service-card.total-service', type: 'number' },
        { field: 'statusString', headerText: 'status.title', type: 'dropdown', options: this.listStatus }
      ];
      let listExport = formatDataExport(dataExport, configColumn, this.translate);
      exportAsExcelFile(listExport, this.translate.instant('service-card.list') + '_' + this.datePipe.transform(new Date(), 'yyMMdd'), this.noti, this.translate);
    }, (error: any) => {
      this.service.handleError(error)
    });
  }

  exchange() {
    if (!this.checkedRowsSelected()) return;
    if (this.selectedRow.status === ServiceCardStatus.Block) {
      this.noti.create('error', '', this.translate.instant('service-card.error-exchange-card-block'));
      return;
    }
    const body = {
      service_card_id: this.selectedRow.card_id,
      apartment_id: this.selectedRow.apartment_id,
      balance_type: BalanceType.ServiceVoucher
    }
    this.service.getCardVoucherFund(body).subscribe((res: any) => {
      if (res && res.data.length > 0) {
        const modalRef = this.modalService.create({
          nzContent: ExchangeItemComponent,
          nzWidth: '90vw',
          nzClassName: 'modal-exchange',
          nzData: {
            id: this.selectedRow.card_id,
            listDetailService: res.data[0].services,
            listDetailCash: res.data[0].cashes
          },
        });
        modalRef.afterClose.subscribe(result => {
          if (result) {
            this.getData();
          }
        });
      } else {
        this.noti.error('', this.translate.instant('service-card.error-exchange-card'));
      }
    })
  }
}
